import React, { useEffect, useState } from 'react';

const MemberList = () => {
    const [users, setUsers] = useState([]);
    // const [updateAudio, setUpdateAudio] = useState(null);

    useEffect(() => {
        fetch(`https://madrumi.thakurgaonexpress.com/getmembers`)
            .then(res => res.json())
            .then(data => {
                setUsers(data)
            })
    }, [])

    return (
        <div className='mt-0'>
            <h1 className='text-3xl pt-4 mb-0 font-bold'>মাদ্‌রাসা-এ জালালুদ্দীন রূমী</h1>
            <h1 className='text-2xl pt-4 mb-8 font-bold'>আজীবন দাতা সদস্য লিস্ট</h1>
            <div class="overflow-x-auto">
                <table class="table w-full">
                    <thead>
                        <tr>
                            <th>ক্রঃ</th>
                            <th>সদস্যের নাম</th>
                            <th>মোবাইল নম্বর</th>
                            <th>পিতা/স্বামীর নাম</th>
                            <th>বয়স</th>
                            <th>পেশা</th>
                            <th>মাধ্যমের নাম,মোবাইল</th>
                            <th>স্থায়ী ঠিকানা</th>
                            <th>বর্তমান ঠিকানা</th>
                            <th>দানের পরিমাণ</th>
                            <th>ধরন</th>
                            <th>পরিশোধের মাধ্যম</th>
                        </tr>
                    </thead>
                    <tbody>
                        {

                            users.map((user, index) => <tr className='hover'>
                            <td>{index + 1}</td>
                            <td>{user?.name}</td>
                            <td>{user?.mobile}</td>
                            <td>{user?.guardian_name}</td>
                            <td>{user?.age}</td>
                            <td>{user?.occupation}</td>
                            <td>{`${user?.medium_name},${user?.medium_phone}`}</td>
                            <td>{`${user?.fixed_village},${user?.fixed_thana},${user?.fixed_district}`}</td>
                            <td>{`${user?.current_village},${user?.current_thana},${user?.current_district}`}</td>
                            <td>{user?.custom_amount?user?.custom_amount:user?.donation_type}</td>
                            <td>{user?.custom_donation_type}</td>
                            <td>{user?.payment_type}</td>
                        </tr>)
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </tfoot>
                </table>
            </div>
            {/* {
                updateAudio && <UpdateModal setUpdateAudio={setUpdateAudio} updateAudio={updateAudio}></UpdateModal>
            } */}
        </div>
    );
};

export default MemberList;